import * as tslib_1 from "tslib";
import { TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_VIEW } from "./../../../../crossconcern/utilities/properties/tablelist.property";
import { ButtonsModel } from "./../../../../crossconcern/models/tablelist/button.model";
import { BaseComponent } from "./../../../base/base.component";
import { TableInfoHeader } from "./../../../../crossconcern/models/tablelist/tableinfoheader.model";
import { AlertUtils } from "./../../../../crossconcern/utilities/utils/alert.utils";
import { LogManager } from "./../../../../business/managers/log.manager";
import { ListInfo } from "./../../../../datastore/entities/listinfo.model";
import { TableInfo } from "./../../../../crossconcern/models/tablelist/tableinfo.model";
import { AppComponent } from "./../../../app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { finalize } from "rxjs/operators";
import { PhotosphereManager } from "../../../../business/managers/photosphere.manager";
var LogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LogComponent, _super);
    function LogComponent(appComponent, router, location, photosphereManager, logManager, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.photosphereManager = photosphereManager;
        _this.logManager = logManager;
        _this.alertUtils = alertUtils;
        _this.userItemsPerPage = 15;
        _this.detailItemsPerPage = 5;
        _this.currentLogDetail = null;
        _this.tables = {
            "user": {
                tableInfo: undefined,
                listInfo: null,
                sortField: "",
                sortAsc: false,
                currentPage: 0
            },
            "photosphere": {
                tableInfo: undefined,
                listInfo: null,
                sortField: "",
                sortAsc: false,
                currentPage: 0
            },
            "promotion": {
                tableInfo: undefined,
                listInfo: null,
                sortField: "",
                sortAsc: false,
                currentPage: 0
            },
            "product": {
                tableInfo: undefined,
                listInfo: null,
                sortField: "",
                sortAsc: false,
                currentPage: 0
            }
        };
        return _this;
    }
    LogComponent.prototype.ngOnInit = function () {
        this.getLogList();
    };
    LogComponent.prototype.getLogList = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.logManager.getLogs(this.userItemsPerPage, this.tables.user.currentPage)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function (logList) {
            // this.listInfo = listInfo;
            _this.logList = logList;
            _this.setUserTable();
        });
    };
    LogComponent.prototype.onPageChanged = function (num, table) {
        this.tables[table].currentPage = num;
        switch (table) {
            case "user":
                this.getLogList();
                break;
            case "photosphere":
                this.setPhotosphereTable();
                break;
            case "promotion":
                this.setPromotionTable();
                break;
            case "product":
                this.setProductsTable();
                break;
        }
    };
    LogComponent.prototype.onHeaderClick = function (sort, table) {
        this.tables[table].sortField = sort[0];
        this.tables[table].sortAsc = sort[1];
        this.getLogList();
    };
    LogComponent.prototype.onViewDetailClick = function (index) {
        this.currentLogDetail = this.logList.logs[index];
        this.setUserDetailTables();
    };
    LogComponent.prototype.setUserDetailTables = function () {
        this.setPhotosphereTable();
        this.setPromotionTable();
        this.setProductsTable();
    };
    LogComponent.prototype.setUserTable = function () {
        var _this = this;
        var headers = {
            "name": new TableInfoHeader("LOG_COMPONENT_USER_TABLE_NAME", false, this.tables.user.sortAsc === true, this.tables.user.sortField === "name"),
            "email": new TableInfoHeader("LOG_COMPONENT_USER_TABLE_EMAIL", false, this.tables.user.sortAsc === true, this.tables.user.sortField === "email"),
            "actions": new TableInfoHeader("LOG_COMPONENT_USER_TABLE_DETAIL", false, false, false)
        };
        var items = [];
        for (var _i = 0, _a = this.logList.logs; _i < _a.length; _i++) {
            var log = _a[_i];
            items.push({
                "name": (log.user.firstName) ? log.user.firstName : "",
                "email": (log.user.email) ? log.user.email : ""
            });
        }
        var buttons = [];
        buttons.push(new ButtonsModel("NURSERY_COMPONENT_TABLE_BUTTON_VIEW", TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_VIEW, function (item) {
            _this.onViewDetailClick(item);
        }));
        this.tables.user.listInfo = this.logList.listInfo;
        this.tables.user.tableInfo = new TableInfo(headers, items, this.userItemsPerPage, buttons);
    };
    LogComponent.prototype.setPhotosphereTable = function () {
        var headers = {
            "nurseryName": new TableInfoHeader("LOG_COMPONENT_SPHERE_TABLE_NURSERY_NAME", false, this.tables.photosphere.sortAsc === true, this.tables.photosphere.sortField === "nurseryName"),
            "name": new TableInfoHeader("LOG_COMPONENT_SPHERE_TABLE_NAME", false, this.tables.photosphere.sortAsc === true, this.tables.photosphere.sortField === "name"),
            "time": new TableInfoHeader("LOG_COMPONENT_SPHERE_TABLE_TIMES", false, this.tables.photosphere.sortAsc === true, this.tables.photosphere.sortField === "time")
        };
        var items = [];
        var spheres = this.currentLogDetail.photospheres.slice(this.detailItemsPerPage * this.tables.photosphere.currentPage, this.detailItemsPerPage * (this.tables.photosphere.currentPage + 1) > this.currentLogDetail.photospheres.length
            ? this.currentLogDetail.photospheres.length
            : this.detailItemsPerPage * (this.tables.photosphere.currentPage + 1));
        for (var _i = 0, spheres_1 = spheres; _i < spheres_1.length; _i++) {
            var photosphere = spheres_1[_i];
            items.push({
                "nurseryName": (photosphere.photosphere.nursery && photosphere.photosphere.nursery.name) ?
                    photosphere.photosphere.nursery.name : "-",
                "name": (photosphere.photosphere.name) ? photosphere.photosphere.name : "",
                "time": (photosphere.time != null) ? photosphere.time : ""
            });
        }
        var totPages = this.currentLogDetail.photospheres.length % this.detailItemsPerPage === 0
            ? Math.floor(this.currentLogDetail.photospheres.length / this.detailItemsPerPage)
            : Math.floor(this.currentLogDetail.photospheres.length / this.detailItemsPerPage) + 1;
        this.tables.photosphere.listInfo = new ListInfo({
            totalElements: this.currentLogDetail.photospheres.length,
            totalPages: totPages,
            numberOfElements: spheres.length,
            first: this.tables.photosphere.currentPage === 0,
            last: this.tables.photosphere.currentPage === totPages - 1,
            sort: {},
            number: this.tables.photosphere.currentPage,
            size: this.detailItemsPerPage
        });
        this.tables.photosphere.tableInfo = new TableInfo(headers, items, this.detailItemsPerPage);
    };
    LogComponent.prototype.setPromotionTable = function () {
        var headers = {
            "title": new TableInfoHeader("LOG_COMPONENT_PROMO_TABLE_TITLE", false, this.tables.promotion.sortAsc === true, this.tables.promotion.sortField === "title")
        };
        var items = [];
        var promotions = this.currentLogDetail.promotions.slice(this.detailItemsPerPage * this.tables.promotion.currentPage, this.detailItemsPerPage * (this.tables.promotion.currentPage + 1) > this.currentLogDetail.promotions.length
            ? this.currentLogDetail.promotions.length
            : this.detailItemsPerPage * (this.tables.promotion.currentPage + 1));
        for (var _i = 0, promotions_1 = promotions; _i < promotions_1.length; _i++) {
            var promotion = promotions_1[_i];
            items.push({
                "title": (promotion.title) ? promotion.title : ""
            });
        }
        var totPages = this.currentLogDetail.promotions.length % this.detailItemsPerPage === 0
            ? Math.floor(this.currentLogDetail.promotions.length / this.detailItemsPerPage)
            : Math.floor(this.currentLogDetail.promotions.length / this.detailItemsPerPage) + 1;
        this.tables.promotion.listInfo = new ListInfo({
            totalElements: this.currentLogDetail.promotions.length,
            totalPages: totPages,
            numberOfElements: promotions.length,
            first: this.tables.promotion.currentPage === 0,
            last: this.tables.promotion.currentPage === totPages - 1,
            sort: {},
            number: this.tables.promotion.currentPage,
            size: this.detailItemsPerPage
        });
        this.tables.promotion.tableInfo = new TableInfo(headers, items, this.detailItemsPerPage);
    };
    LogComponent.prototype.setProductsTable = function () {
        var headers = {
            "name": new TableInfoHeader("LOG_COMPONENT_PROD_TABLE_NAME", false, this.tables.product.sortAsc === true, this.tables.product.sortField === "name")
        };
        var items = [];
        var products = this.currentLogDetail.products.slice(this.detailItemsPerPage * this.tables.product.currentPage, this.detailItemsPerPage * (this.tables.product.currentPage + 1) > this.currentLogDetail.products.length
            ? this.currentLogDetail.products.length
            : this.detailItemsPerPage * (this.tables.product.currentPage + 1));
        var language = this.photosphereManager.getCurrentLanguage();
        for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
            var product = products_1[_i];
            var productName = this.getProductName(product, language);
            items.push({
                "name": productName ? productName : ""
            });
        }
        var totPages = this.currentLogDetail.products.length % this.detailItemsPerPage === 0
            ? Math.floor(this.currentLogDetail.products.length / this.detailItemsPerPage)
            : Math.floor(this.currentLogDetail.products.length / this.detailItemsPerPage) + 1;
        this.tables.product.listInfo = new ListInfo({
            totalElements: this.currentLogDetail.products.length,
            totalPages: totPages,
            numberOfElements: products.length,
            first: this.tables.product.currentPage === 0,
            last: this.tables.product.currentPage === totPages - 1,
            sort: {},
            number: this.tables.product.currentPage,
            size: this.detailItemsPerPage
        });
        this.tables.product.tableInfo = new TableInfo(headers, items, this.detailItemsPerPage);
        this.tables.product.tableInfo = new TableInfo(headers, items, this.detailItemsPerPage);
    };
    LogComponent.prototype.onBackClick = function () {
        this.currentLogDetail = null;
    };
    return LogComponent;
}(BaseComponent));
export { LogComponent };
